export default "__VITE_PUBLIC_ASSET__112d1a08__"